import React from 'react';

interface SectionTitleProps {
  title: string;
  subtitle?: React.ReactNode;
  className?: string;
  titleClassName?: string;
  subtitleClassName?: string;
}

export const SectionTitle: React.FC<SectionTitleProps> = ({
  title,
  subtitle,
  className = "text-center mb-16 md:mb-20",
  titleClassName = "text-4xl sm:text-5xl lg:text-6xl font-serif font-bold text-brand-light mb-4",
  subtitleClassName = "text-base sm:text-lg text-brand-text max-w-2xl mx-auto"
}) => {
  return (
    <div className={`${className}`}>
      <h2 className={`${titleClassName}`}>{title}</h2>
      {subtitle && <p className={`${subtitleClassName}`}>{subtitle}</p>}
    </div>
  );
};